import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { NoGroup } from 'components/core/no_group';
const tableCss = "t1nr07lu";
const Table = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'table';
  return <Component ref={ref} {...restProps} className={classNames(tableCss, props.className)} />;
});
const tableHeadCss = "t11mfahu";
const TableHead = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'thead';
  return <Component ref={ref} {...restProps} className={classNames(tableHeadCss, props.className)} />;
});
const tableBodyCss = "tvbl7pu";
const TableBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'tbody';
  return <Component ref={ref} {...restProps} className={classNames(tableBodyCss, props.className)} />;
});
const tableRowCss = "tlkhdu6";
const TableRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'tr';
  return <Component ref={ref} {...restProps} className={classNames(tableRowCss, props.className)} />;
});
const tableHeaderCellCss = "t1t80rea";
const TableHeaderCell = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'th';
  return <Component ref={ref} {...restProps} className={classNames(tableHeaderCellCss, props.className)} />;
});
const tableCellCss = "t11634su";
const TableCell = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'td';
  return <Component ref={ref} {...restProps} className={classNames(tableCellCss, props.className)} />;
});
const nameContainerCss = "ngig3zx";
const NameContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(nameContainerCss, props.className)} />;
});
const styledAvatarCss = "sxvs8o0";
const StyledAvatar = forwardRef((props, ref) => {
  const size = 'small';
  return <FullStoryExclude>
      <Avatar ref={ref} {...props} size={size} className={classNames(styledAvatarCss, props.className)} />
    </FullStoryExclude>;
});
export const MembersTable = ({
  memberships
}) => <Table>
    <TableHead>
      <tr>
        <TableHeaderCell>
          {I18n.t('publisher.organization.headers.name')}
        </TableHeaderCell>
        <TableHeaderCell>
          {I18n.t('publisher.organization.headers.group')}
        </TableHeaderCell>
      </tr>
    </TableHead>
    <TableBody>
      {memberships.map(membership => <TableRow key={membership.id}>
          <TableCell>
            <NameContainer>
              <StyledAvatar letter={membership.avatar_letter} src={membership.avatar_url} />
              <BodyText><FullStoryMask>{membership.name}</FullStoryMask></BodyText>
            </NameContainer>
          </TableCell>
          <TableCell>
            {membership.user_group_membership && membership.user_group_membership.group_name ? <FullStoryMask>
                {membership.user_group_membership.group_name}
              </FullStoryMask> : <NoGroup />}
          </TableCell>
        </TableRow>)}
    </TableBody>
  </Table>;

require("./members_table.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./members_table.js");